import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	replaceExisting: Yup.bool(),
	existingTemplates: Yup.array().nullable(),
	name: Yup.string().when('existingTemplates', {
		is: (existingTemplates) => (existingTemplates ?? []).length > 0,
		then: (schema) =>
			schema
				.required('Name is required.')
				.test('unique-name', 'A template with this name already exists.', function (value) {
					console.log('EXISTING TEMPLATES', this.parent.existingTemplates);
					if (!value) return false;
					if (this.parent.replaceExisting) return true;

					const nameExists = this.parent.existingTemplates.some(
						(file) => file?.name === (value ?? '').trim(),
					);
					return !nameExists;
				}),
		otherwise: (schema) => schema.required('Name is required.'),
	}),
	requirements: Yup.array().nullable(),
	type: Yup.string().when('requirements', {
		is: (requirements) => (requirements ?? []).includes('statementOfAdvice'),
		then: (schema) =>
			schema
				.oneOf(
					['statementOfAdvice'],
					'Email template type must be statement of advice due to required fields in the template.',
				)
				.required(
					'Email template type must be statement of advice due to required fields in the template.',
				),
		otherwise: (schema) => schema.required('Type is required.'),
	}),
});

export default validationSchema;
